import Vue from 'vue'
import VueRouter from 'vue-router'
// Configuracion

import EmpleadosView from './views/configuraciones/Empleados.view.vue'
import UsuariosView from './views/configuraciones/accesos/usuarios.view.vue'
import RolesView from './views/configuraciones/accesos/roles.view.vue'
import PermisosView from './views/configuraciones/accesos/permisos.view.vue'
import DepartamentoView from './views/catalogo/Departamentos.view.vue'
import TipoProcesoView from './views/catalogo/TiposProcesos.view.vue'
import TiposContratosView from './views/catalogo/TiposContratos.view.vue'
import BancosView from './views/catalogo/Bancos.view.vue'
import UbpsView from './views/catalogo/Ubps.view.vue'
import ActividadesEconomicasView from './views/catalogo/ActividadesEconomicas.view.vue'
import PartidasView from './views/catalogo/Partidas.view.vue'
import FuentesFinanciamientoView from './views/catalogo/FuentesFinanciamiento.view.vue'
import FormCaracteristicaView from './views/configuraciones/FormCaracteristicas.view.vue'
// Catalogos
import FamiliasView from './views/catalogo/Familias.view.vue'
import MarcasView from './views/catalogo/Marcas.view.vue'
import TiposDatosView from './views/catalogo/TipoDato.view.vue'
import ProcedenciaView from './views/catalogo/Procedencia.view.vue'
import CaracteristicasView from './views/catalogo/Caracteristicas.view.vue'
import ConceptosView from './views/catalogo/ConceptosBajas.view.vue'
// Inventarios
import BienesView from './views/inventarios/bienes.view.vue'
import ControlablesView from './views/inventarios/Controlables.view.vue'
import BajasView from './views/inventarios/bajas.view.vue'
import TransferenciaView from './views/inventarios/transferencias.view.vue'
import SolicitudesAltasView from './views/inventarios/InventarioAltas.view'

// Solicitudes
import InventarioDepartamentoView from './views/inventarios/InventarioDepartamento.view.vue'
import InventarioEmpleadoView from './views/inventarios/InventarioEmpleado.view.vue'
// Configuraciones
import PanelEmpresaView from './views/configuraciones/procesos/PanelEmpresa.view.vue'
import EmpleadosSinInventarioView from './views/company/EmpleadosSinInventario.view.vue'

// Configuraciones -Procesos
import ConfigProcesTipoActividadView from './views/configuraciones/procesos/TiposActiviades.view.vue'
import ConfigProcesProcesView from './views/configuraciones/procesos/Procesos.view.vue'
import ConfigProcesConfigProcesView from './views/configuraciones/procesos/ConfiguracionProceso.view.vue'
import ConfigProcesEstatusProcesView from './views/configuraciones/procesos/EstatusProcesos.view.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [],
        name: ''
      }
    },
    {
      path: '/home',
      name: 'home',
      // beforeEnter
      meta: {
        allowAnonymous: true,
        breadcrumb: [{ name: 'Inicio' }],
        name: 'Sistema de Administración y Control de Bienes y Servicios'
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/home.view.vue')
    },
    // ========== Configuraciones ========== \\
    {
      path: '/Configuraciones/Empleados',
      name: 'ConfigEmpleadosView',
      meta: {
        allowAnonymous: true,
        name: 'Empleados',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Empleados' }]
      },
      component: EmpleadosView
    },
    {
      path: '/Configuraciones/accesos/Usuarios',
      name: 'ConfigAuthUsersView',
      meta: {
        allowAnonymous: true,
        name: 'Usuarios',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Usuarios' }]
      },
      component: UsuariosView
    },
    {
      path: '/Configuraciones/Acceso/Roles',
      name: 'ConfigAuthRolsView',
      meta: {
        allowAnonymous: true,
        name: 'Roles',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Roles' }]
      },
      component: RolesView
    },
    {
      path: '/Configuraciones/Acceso/Permisos',
      name: 'ConfigAuthPermissView',
      meta: {
        allowAnonymous: true,
        name: 'Permisos',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Permisos' }]
      },
      component: PermisosView
    },
    {
      path: '/Configuraciones/FormFamiliaCaracterristicas',
      name: 'FormCaracteristicaView',
      meta: {
        allowAnonymous: true,
        name: 'Formulario de Familia-Caracteristicas',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Formulario de Familia y Caracteristicas' }]
      },
      component: FormCaracteristicaView
    },
    // ========== Catalogos ========== \\
    {
      path: '/catalogos/Departamentos',
      name: 'DepartamentoView',
      meta: {
        allowAnonymous: true,
        name: 'Departamentos',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'Departamentos' }
        ]
      },
      component: DepartamentoView
    },
    {
      path: '/catalogos/familias',
      name: 'FamiliasView',
      meta: {
        allowAnonymous: true,
        name: 'Familia',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Familia' }
        ]
      },
      component: FamiliasView
    },
    {
      path: '/catalogos/tiposprocesos',
      name: 'TipoProcesoView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos Procesos',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Tipos Procesos' }
        ]
      },
      component: TipoProcesoView
    },
    {
      path: '/catalogos/tiposcontratos',
      name: 'TiposContratosView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos Contratos',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Tipos Contratoss' }
        ]
      },
      component: TiposContratosView
    },
    {
      path: '/catalogos/bancos',
      name: 'BancosView',
      meta: {
        allowAnonymous: true,
        name: 'Bancos',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Bancos' }
        ]
      },
      component: BancosView
    },
    {
      path: '/catalogos/ubps',
      name: 'UbpsView',
      meta: {
        allowAnonymous: true,
        name: 'Ubps',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Ubps' }
        ]
      },
      component: UbpsView
    },
    {
      path: '/catalogos/actividadesesconomicas',
      name: 'ActividadesEconomicasView',
      meta: {
        allowAnonymous: true,
        name: 'ActividadesEconomicas',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'ActividadesEconomicas' }
        ]
      },
      component: ActividadesEconomicasView
    },
    {
      path: '/catalogos/partidas',
      name: 'PartidasView',
      meta: {
        allowAnonymous: true,
        name: 'Partidas',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Partidas' }
        ]
      },
      component: PartidasView
    },
    {
      path: '/catalogos/fuentesfinanciamiento',
      name: 'FuentesFinanciamientoView',
      meta: {
        allowAnonymous: true,
        name: 'Fuentes Financiamiento',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Fuentes Financiamiento' }
        ]
      },
      component: FuentesFinanciamientoView
    },
    {
      path: '/catalogos/ConceptosBajas',
      name: 'ConceptosView',
      meta: {
        allowAnonymous: true,
        name: 'Conceptos De Bajas',
        breadcrumb: [
          { name: 'Catalogos' },
          { name: 'Conceptos De Baja' }
        ]
      },
      component: ConceptosView
    },
    {
      path: '/Catalogos/Marcas',
      name: 'MarcasView',
      meta: {
        allowAnonymous: true,
        name: 'Marcas',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'Marcas' }
        ]
      },
      component: MarcasView
    },
    {
      path: '/Catalogos/Procedencia',
      name: 'ProcedenciaView',
      meta: {
        allowAnonymous: true,
        name: 'Procedencia',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'Procedencia' }
        ]
      },
      component: ProcedenciaView
    },
    {
      path: '/Catalogos/Caracteristicas',
      name: 'CaracteristicasView',
      meta: {
        allowAnonymous: true,
        name: 'Caracteristicas',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'Caracteristicas' }
        ]
      },
      component: CaracteristicasView
    },
    {
      path: '/Catalogos/TiposDatos',
      name: 'TiposDatosView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Datos',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Tipos de Datos' }]
      },
      component: TiposDatosView
    },
    // ============================================================== \\
    // ============================================================== \\
    // ============================================================== \\
    // Mesa de ayuda \\
    {
      path: '/seguimientos',
      name: 'SeguimientosView',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Sistema de archivos' },
          { name: 'Seguimientos' }
        ],
        name: 'Seguimientos'
      },
      component: () => import('./views/seguimientos/seguimientos.view.vue')
    },
    {
      path: '/facturas',
      name: 'FacturasView',
      meta: {
        allowAnonymous: true,
        name: 'Facturas',
        breadcrumb: [
          { name: 'Facturas' }
        ]
      },
      component: () => import('./views/inventarios/facturas.view.vue')
    },
    {
      path: '/proveedores',
      name: 'ProveedoresView',
      meta: {
        allowAnonymous: true,
        name: 'Proveedores',
        breadcrumb: [
          { name: 'Proveedores' }
        ]
      },
      component: () => import('./views/proveedores/proveedores.view.vue')
    },
    {
      path: '/contratos',
      name: 'ContratosView',
      meta: {
        allowAnonymous: true,
        name: 'Contratos',
        breadcrumb: [
          { name: 'Contratos' }
        ]
      },
      component: () => import('./views/inventarios/contratos.view.vue')
    },
    // * ========== * ========== *       Invetarios        * ========== * ========== * \\
    // * ========== * ========== * ========== * ========== * ========== * ========== * \\
    {
      path: '/Bienes/Controlables',
      name: 'InvBienesC',
      meta: {
        allowAnonymous: true,
        name: 'Controlables',
        breadcrumb: [
          { name: 'Bienes' },
          { name: 'Controlables' }
        ]
      },
      component: ControlablesView
    },

    // Catalogos \\
    {
      path: '/Catalogo/Roles/Permisos/:id',
      name: 'ViewPermissionsRoleAssign',
      meta: {
        allowAnonymous: true,
        name: 'Asignar Permisos a Rol',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Roles' },
          { name: 'Asignacion de Permisos' }
        ]
      },
      component: () => import('./views/company/rolePermissionsAssign.view.vue')
    },
    // Inventarios \\
    {
      path: '/Inventarios/Bienes',
      name: 'InvBienes',
      meta: {
        allowAnonymous: true,
        name: 'Bienes Inventariables',
        breadcrumb: [{ name: 'Inventarios' }, { name: 'Bienes' }]
      },
      component: BienesView
    },
    {
      path: '/Solicitudes/Bajas',
      name: 'BajasView',
      meta: {
        allowAnonymous: true,
        name: 'Solicitudes De Bajas',
        breadcrumb: [
          { name: 'Solicitudes' },
          { name: 'Bajas' }
        ]
      },
      component: BajasView
    },
    {
      path: '/Solicitudes/Transferencias',
      name: 'TransferenciaView',
      meta: {
        allowAnonymous: true,
        name: 'Solicitudes De Transferencias',
        breadcrumb: [
          { name: 'Solicitudes' },
          { name: 'Transferencias' }
        ]
      },
      component: TransferenciaView
    },
    {
      path: '/Inventarios/Solicitudes/Altas',
      name: 'SolicitudesAltasView',
      meta: {
        allowAnonymous: true,
        name: 'Solicitudes de Inventario Altas',
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Solicitudes' },
          { name: 'Altas' }
        ]
      },
      component: SolicitudesAltasView
    },

    {
      path: '/Solicitudes/Inventario/Departamento',
      name: 'InventarioDepartamentoView',
      meta: {
        allowAnonymous: true,
        name: 'Inventario de Departamentos',
        breadcrumb: [
          { name: 'Solicitudes' },
          { name: 'Inventario de los Departamento' }
        ]
      },
      component: InventarioDepartamentoView
    },
    {
      path: '/Solicitudes/Inventario/Empleado',
      name: 'InventarioEmpleadoView',
      meta: {
        allowAnonymous: true,
        name: 'Personal de baja con bienes asignados',
        breadcrumb: [
          { name: 'Inventario' },
          { name: 'Personal de baja con bienes asignados' }
        ]
      },
      component: InventarioEmpleadoView
    },

    // Configuraciones \\
    {
      path: '/Configuraciones/TiposProcesos',
      name: 'ViewProcesos',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Procesos',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Tipos de Procesos' }
        ]
      },
      component: () => import('./views/company/configuraciones/procesos.view.vue')
    },
    {
      path: '/Configuraciones/RutinasProcesos/PanelEmpresa',
      name: 'ConfigRutProcPanelEmpresa',
      meta: {
        allowAnonymous: true,
        name: 'Panel de Datos de Empresa',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Rutinas y Procesos' }, { name: 'Panel de Empresa' }]
      },
      component: PanelEmpresaView
    },
    {
      path: '/Configuraciones/Empleados/SinInventarios',
      name: 'EmpledosSinInventarioView',
      meta: {
        allowAnonymous: true,
        name: 'Empledos Sin Inventario',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Empledos' }, { name: 'Sin Inventario' }]
      },
      component: EmpleadosSinInventarioView
    },

    // Configuraciones - Procesos \\

    {
      path: '/Configuraciones/Procesos/TiposActividades',
      name: 'ConfigProcesTipoActividadView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Actividades',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Procesos' }, { name: 'Tipos de Actividades' }]
      },
      component: ConfigProcesTipoActividadView
    },
    {
      path: '/Configuraciones/Procesos/Procesos',
      name: 'ConfigProcesProcesView',
      meta: {
        allowAnonymous: true,
        name: 'Procesos del Sistema',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Procesos' }, { name: 'Procesos' }]
      },
      component: ConfigProcesProcesView
    },
    {
      path: '/Configuraciones/Procesos/ConfiguracionProceso',
      name: 'ConfigProcesConfigProcesView',
      meta: {
        allowAnonymous: true,
        name: 'Configuracion de Procesos',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Procesos' }, { name: 'Configuracion de Procesos' }]
      },
      component: ConfigProcesConfigProcesView
    },
    {
      path: '/Configuraciones/Procesos/EstatusProcesos',
      name: 'ConfigProcesEstatusProcesView',
      meta: {
        allowAnonymous: true,
        name: 'Estatus de Procesos',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Procesos' }, { name: 'Estatus de Procesos' }]
      },
      component: ConfigProcesEstatusProcesView
    }
    // Fin Configuraciones Fin \\
  ]
})
